import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiLoader } from 'react-icons/fi';

const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <SafeIcon icon={FiLoader} className="text-4xl text-blue-600 animate-spin mb-4" />
      <p className="text-gray-600">Loading ocean data...</p>
    </div>
  );
};

export default LoadingSpinner;